export const environment = {
  name: 'dev',
  apiUrl: 'https://dev.mib.motion.abb.com',
  authClientId: 'pmhDL2OLuIGvcxXJFDXfi608qXIa',
  authority: 'https://stage.polaris.iam.motion.abb.com/oauth2/token',
  authWellknownEndpointUrl: 'https://stage.api.accessmanagement.motion.abb.com/polaris/oidc/.well-known/openid-configuration',
  authRedirectUrl: 'https://dev.mib.motion.abb.com/ui/callback',
  authLogoutUrl: 'https://dev.mib.motion.abb.com/ui/logout',
  appInsightsConnString: 'InstrumentationKey=4d03a84a-6fd9-44cd-8e89-907d13da074f;IngestionEndpoint=https://westeurope-4.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=ecaebc08-67fa-4606-a3b7-f687ef4e63e7'
};
